<ng-container *transloco="let t; read: 'configuration'">
<div class="rounded-lg fix-action-row modal-body">
  <div class="flex justify-between border-b pb-5">
    <h1 class="text-[25px] font-bold">{{title}}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-2 gap-4 gap-x-10" [formGroup]="customConfigForm">

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold required" for="Demographics Section">{{ t('stateConfiguration.customConfig.demographicsSection') }}</label>
        <div class="col-span-1 items-center w-[100%]">
          <mat-form-field id="Demographics" appearance="fill">
            <mat-select formControlName="sectionId" [placeholder]="t('ratingViewSetup.selectOption')">
              <!-- Server-supplied option text: localized by the API, not by Transloco. -->
              @for (section of sectionOptions$ | async; track section) {
                <mat-option [value]="section.id"> {{ section.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold required" for="Field Label">{{ t('stateConfiguration.customConfig.fieldLabel') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('stateConfiguration.customConfig.addFieldLabel')"
            autocomplete="off"
            id="label"
            type="text"
            formControlName="label"
            maxlength="100">
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold required" for="Field Type">{{ t('stateConfiguration.customConfig.fieldType') }}</label>
        <div class="col-span-1 items-center w-[100%]">
          <mat-form-field id="Field" appearance="fill">
            <mat-select formControlName="customFieldTypeId" [placeholder]="t('ratingViewSetup.selectOption')" (selectionChange)="onfieldTypeChange($event)">
              <!-- Server-supplied option text: localized by the API, not by Transloco. -->
              @for (type of fieldTypeOptions$ | async; track type) {
                <mat-option [value]="type.id"> {{ type.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold required" for="Sort Order">{{ t('stateConfiguration.customConfig.sortOrder') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('stateConfiguration.customConfig.addSortOrder')"
            autocomplete="off"
            id="orderBy"
            type="number"
            formControlName="orderBy"
            maxlength="5">
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold" for="Maximum Length of Characters" [ngClass]="{ 'required' : isMaxRequired}">{{ t('stateConfiguration.customConfig.maxLength') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('stateConfiguration.customConfig.addMaxLength')"
            autocomplete="off"
            id="maxLength"
            type="number"
            formControlName="maxLength"
            max="1000"
            maxlength="4">
        </mat-form-field>
        @if (maxLength.value > 1000) {
          <mat-error>{{ t('stateConfiguration.customConfig.maxLengthError') }} </mat-error>
        }
      </div>

      <div class="flex w-[100%]">
        <div class="flex flex-col pr-5">
          <label class="font-bold" for="Status">{{ t('common.active') }}</label>
          <mat-slide-toggle formControlName="isActive"
            [color]="'primary'">
          </mat-slide-toggle>
        </div>
        <div class="flex flex-col">
          <label class="font-bold" for="v">{{ t('common.required') }}</label>
          <mat-slide-toggle formControlName="isRequired"
            [color]="'primary'">
          </mat-slide-toggle>
        </div>
      </div>

      <div class="col-span-2 items-center w-[100%]">
        <label class="font-normal" [ngClass]="{ 'required' : isOptionRequired}" for="Field Type Options">{{ t('stateConfiguration.customConfig.fieldTypeOptions') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput
            [placeholder]="t('stateConfiguration.customConfig.addFieldType')"
            autocomplete="off"
            id="options"
            type="text"
            formControlName="options"
            maxlength="50">
        </mat-form-field>
        @if (options.errors?.error) {
          <mat-error>{{ t('stateConfiguration.customConfig.optionsFormatError') }}</mat-error>
        }
      </div>
    </form>

  </div>
  <div class="spacer"></div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <button mat-button mat-dialog-close>{{ t('common.cancel') }}</button>
    @if (customConfigForm.valid) {
      <drdp-btn mat-button [mat-dialog-close]="onSubmit()" [disabled]="false" cdkFocusInitial>{{ t('common.saveAndSubmit') }}</drdp-btn>
    }
    @if (customConfigForm.invalid) {
      <drdp-btn mat-button [disabled]="true" cdkFocusInitial>{{ t('common.save') }}</drdp-btn>
    }
  </div>
</div>
</ng-container>

